import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hq-template',
  templateUrl: './hq-template.component.html',
  styleUrls: ['./hq-template.component.css']
})
export class HqTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/hq-template/hq-template.component.ts